import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { GrowlerService } from '../../../../../services/growler.service';
import { PaymentMethodsService } from '../../../../../services/financial-accounts/payment-methods.service';
import { GenericDialogResult } from '../../generic-mat-dialog/generic-dialog-result';
import { BankAccountManagerComponent } from '../bank-account-manager.component';

export interface UnlinkBankAccountDialogInput
{
    account: UnifiedBankAccount;
    manager: BankAccountManagerComponent;
}

@Component({
    selector: 'app-unlink-bank-account-dialog',
    templateUrl: './unlink-bank-account-dialog.component.html',
})
export class UnlinkBankAccountDialogComponent implements OnInit
{
    public isDeleteInFlight: boolean = false;

    constructor(
            private _dialogRef: MatDialogRef<UnlinkBankAccountDialogComponent>,
            private _bankAccountsService: BankAccountsService,
            private _growlerService: GrowlerService,
            private _paymentMethodsService: PaymentMethodsService,
            @Inject(MAT_DIALOG_DATA) public data: UnlinkBankAccountDialogInput,
    ) {
    }

    ngOnInit() {
    }

    disableTransactions() {
        this._dialogRef.close(<GenericDialogResult>{success: false});
        this.data.manager.toggleTransactions(this.data.account);
    }

    closeDialog() {
        this._dialogRef.close(<GenericDialogResult>{success: false});
    }

    deleteAccount() {
        this.isDeleteInFlight = true;
        this._bankAccountsService.unlinkExistingBankAccount(null, this.data.account.id).subscribe(
                () => {
                    this._growlerService.success(
                            'Success',
                            'Your bank account has been unlinked.',
                    );
                    this.isDeleteInFlight = true;
                    this._dialogRef.close(<GenericDialogResult>{
                        success: true,
                    });
                },
                () => {
                    this.isDeleteInFlight = true;
                    this._growlerService.error(
                            'Oops...',
                            'There was an error unlinking your bank account.',
                    );
                },
        );
    }
}
